// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="noPaymentMethodHeader">Add a payment method to your wallet</h1>
        </div>
        <div class="hoa-dialog__main">
            <p class="u-textCenter" tid="noPaymentMethodBody2">
                Select Next to add a card or checking account to your wallet. Select Cancel to return to your
                properties.
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130" tid="noPaymentMethodCancel"
                    (click)="closeThisDialog(0)">Cancel
            </button>
            <button class="Button Button--blue Button--minWidth130" tid="noPaymentMethodAdd"
                    (click)="closeThisDialog('Add')">Next
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;